import config from '@/config';
import { requests } from '.';
const MEDIA_SERVICE_URL = config === null || config === void 0 ? void 0 : config.MEDIA_SERVICE_URL;
export const MediaServices = {
    uploadMedia: (body) => requests(MEDIA_SERVICE_URL).post('/upload', body, {
        headers: {
            'source-id': body.locationId,
        },
    }),
};
